import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { firestore } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import Theme from "../components/theme";

function AdminHotlines() {
  const [mode, setMode] = useState("add");
  const [hotlines, setHotlines] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    phoneNumber: "",
    website: "",
  });

  const getHotlines = async () => {
    const snapshot = await getDocs(collection(firestore, "hotlines"));
    setHotlines(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
  };

  useEffect(() => {
    getHotlines();
  }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSelect = (id) => {
    setSelectedId(id);
    const h = hotlines.find((item) => item.id === id);
    if (h) setFormData(h);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (mode === "add") {
        await addDoc(collection(firestore, "hotlines"), formData);
        alert("Hotline added successfully!");
      } else {
        const ref = doc(firestore, "hotlines", selectedId);
        await updateDoc(ref, formData);
        alert("Hotline updated!");
      }
      setFormData({ name: "", description: "", phoneNumber: "", website: "" });
      setSelectedId("");
      getHotlines();
    } catch (err) {
      console.error(err);
      alert("Error saving hotline.");
    }
  };

  const handleDelete = async () => {
    if (!selectedId) return alert("Select a hotline first!");
    if (window.confirm("Are you sure you want to delete this hotline?")) {
      await deleteDoc(doc(firestore, "hotlines", selectedId));
      alert("Deleted successfully!");
      setFormData({ name: "", description: "", phoneNumber: "", website: "" });
      setSelectedId("");
      getHotlines();
    }
  };

  return (
    <Theme>
      <Box className="px-4 sm:px-8 py-6 max-w-screen-md mx-auto">
        <Typography
          color="primary"
          variant="h4"
          align="center"
          sx={{ mb: 4 }}
        >
          Manage Hotlines
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={mode}
            onChange={(e) => setMode(e.target.value)}
            displayEmpty
          >
            <MenuItem value="add">Add New Hotline</MenuItem>
            <MenuItem value="edit">Edit Existing Hotline</MenuItem>
          </Select>
        </FormControl>

        {mode === "edit" && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <Select
              value={selectedId}
              onChange={(e) => handleSelect(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">Select Hotline</MenuItem>
              {hotlines.map((h) => (
                <MenuItem key={h.id} value={h.id}>
                  {h.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Hotline Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <TextField
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            multiline
            rows={3}
            required
          />
          <TextField
            label="Phone Number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          <TextField
            label="Website URL"
            name="website"
            value={formData.website}
            onChange={handleChange}
          />

          <Button variant="contained" type="submit" sx={{ mt: 2 }}>
            {mode === "add" ? "Add Hotline" : "Save Changes"}
          </Button>

          {mode === "edit" && selectedId && (
            <Button
              variant="outlined"
              color="error"
              sx={{ mt: 1 }}
              onClick={handleDelete}
            >
              Delete Hotline
            </Button>
          )}
        </Box>
      </Box>
    </Theme>
  );
}

export default AdminHotlines;
